<div mat-dialog-content style="max-width: 500px">
    <div class="dialog-container custom-scroll">
        <h2>Formularul de contact nr #{{data.contactFormId + 1}}</h2>
        <ul>
            <li> Nume: <b>{{data.contactForm.name}}</b></li>
            <li> Email: <b>{{data.contactForm.email}}</b></li>
            <li> Data postarii: <b>{{data.contactForm.postingDate | date:'dd-MMM-yyyy HH:mm:ss'}}</b></li>
            <li> Subiect: <b>{{data.contactForm.subject}}</b></li>
            <li> Mesaj: <b>{{data.contactForm.message}}</b></li>
            <li> Status:
                <select [(ngModel)]="data.contactForm.status" (change)="changeStatus($event, data.contactForm.id)">
                <option value="new">Nou</option>
                <option value="in_progress">In progres</option>
                <option value="done">Rezolvat</option>
            </select>
            </li>
        </ul>
    </div>
</div>
